// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_shopping-cart.scss
// module id = 52
// module chunks = 0